import api from "../../utils/axios";

export async function listAdminPendingMarketplaceProducts(params = {}) {
  const { data } = await api.get("/v1/admin/marketplace/pending-products", {
    params,
  });

  return data;
}

export async function getAdminPendingMarketplaceProduct(productId) {
  const { data } = await api.get(
    `/v1/admin/marketplace/pending-products/${productId}`,
  );
  return data;
}

export async function getAdminMarketplaceProduct(productId) {
  const { data } = await api.get(`/v1/admin/marketplace/products/${productId}`);
  return data;
}

export async function updateAdminMarketplaceProduct(productId, payload = {}) {
  const { data } = await api.patch(
    `/v1/admin/marketplace/products/${productId}`,
    payload,
  );
  return data;
}

export async function approveAdminPendingMarketplaceProduct(
  productId,
  payload = {},
) {
  const { data } = await api.post(
    `/v1/admin/marketplace/moderation/${productId}/approve`,
    payload,
  );
  return data;
}

export async function rejectAdminPendingMarketplaceProduct(productId, payload) {
  const { data } = await api.post(
    `/v1/admin/marketplace/moderation/${productId}/reject`,
    payload,
  );
  return data;
}

export async function listAdminMarketplaceProducts(params = {}) {
  const { data } = await api.get("/v1/admin/marketplace/products", {
    params,
  });

  return data;
}
